import * as React from 'react';
import { Typography, Box } from '@mui/material';

import { shipmentMonitoringCellTypographySx } from './shipmentMonitoringDefShared';

export const shipmentMonitoringClosureColumns = [
    {
        field: 'client_closure',
        headerName: 'Client Closure',
        width: 70,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        renderHeader: () => (
            <Box sx={{ textAlign: 'center', lineHeight: 1.15 }}>
                <Box component="span" sx={{ display: 'block', fontWeight: 500 }}>
                    Client
                </Box>
                <Box component="span" sx={{ display: 'block', fontWeight: 500 }}>
                    Closure
                </Box>
            </Box>
        ),
        renderCell: (p) => (
            <Typography sx={shipmentMonitoringCellTypographySx}>{p.row.client_closure ?? ''}</Typography>
        ),
    },
    {
        field: 'case_closure',
        headerName: 'Case Closure',
        width: 70,
        align: 'center',
        headerAlign: 'center',
        sortable: false,
        renderHeader: () => (
            <Box sx={{ textAlign: 'center', lineHeight: 1.15 }}>
                <Box component="span" sx={{ display: 'block', fontWeight: 500 }}>
                    Case
                </Box>
                <Box component="span" sx={{ display: 'block', fontWeight: 500 }}>
                    Closure
                </Box>
            </Box>
        ),
        renderCell: (p) => <Typography sx={shipmentMonitoringCellTypographySx}>{p.row.case_closure ?? ''}</Typography>,
    },
];
